import jwtDecode from "jwt-decode";
import { getFirstBusiness } from "./Business/Business";
import { format } from "date-fns";
import i18n from "../i18n";
const DATE_TIME_FORMAT = "yyyy-MM-d";

export const baseUrl =
  process.env.REACT_APP_BRANCH !== "main"
    ? "https://your-fair-share.com/sandbox"
    : "https://your-fair-share.com";

// export const baseUrl = "http://127.0.0.1:8000";

export function isLoggedIn() {
  // console.log(localStorage.getItem('access_token'))
  if (
    localStorage.getItem("access_token") !== null &&
    localStorage.getItem("access_token") !== "undefined"
  ) {
    const decodedJwt = jwtDecode(localStorage.getItem("access_token"));
    // // console.log(decodedJwt.exp,Date.now())
    if (decodedJwt.exp * 1000 < Date.now()) {
      return false;
    }
    if (
      localStorage.getItem("id_business") == null ||
      localStorage.getItem("id_business") === "undefined"
    ) {
      getFirstBusiness({});
    }

    return true;
  } else {
    return false;
  }
}

export function isNewlyRegistered() {
  if (
    localStorage.getItem("newly_registered_az") == null ||
    localStorage.getItem("newly_registered_az") === "undefined"
  )
    return false;
  return true;
}

export const convertDate = (date) => {
  if (typeof date == "string") {
    const dates = date.replaceAll(".", "/").split("/");
    const newDate = dates[2] + "-" + dates[1] + "-" + dates[0];
    return newDate;
  }
  return date;
};

export const getCurrentYear = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  return currentYear;
};

export const formatDate = (date, format_custom = DATE_TIME_FORMAT) => {
  // console.log(format(new Date(date), format_custom))
  return format(new Date(date), format_custom);
};

export function deleteToken() {
  localStorage.removeItem("access_token");
}

export const defaultAddErrorMessage =
  "Failed to add object! Please check the error message";
export const defaultUpdateErrorMessage =
  "Failed to update object! Please check the error message";

export const errorTranslate = () => {
  const getLanguage = () => i18n.language;
  return getLanguage() === "en" ? "Error!" : "Fejl!";
};

export const fontReport = (width, CONST_WIDTH, percent, unit) => {
  return width ? width * percent + unit : CONST_WIDTH * percent + unit;
};

export const objectifyForDropdown = (data) => {
  if (typeof data == "string") {
    return { label: data, value: data, name: data };
  } else if (!data) {
    return {};
  } else {
    return data;
  }
};

export const formatDateTotalCategory = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDateYYYYMMDD = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const parseDateFromYYYYMMDD = (dateString) => {
  if (!dateString) return new Date(); // Fallback to current date if no date is provided
  return new Date(dateString);
};

// Utility to ensure payload values are always in dot format for API calls
export const ensurePayloadFormat = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  // Convert to string and replace comma with dot
  const stringValue = String(value);
  return stringValue.replace(",", ".");
};

// Utility to format numbers for API/payload (always dot format)
export const formatForPayload = (value) => {
  if (value === null || value === undefined) {
    return value;
  }

  // Ensure it's a number first, then convert to string with dot
  const numValue = Number(ensurePayloadFormat(value));
  if (isNaN(numValue)) {
    return value; // Return original if not a valid number
  }

  return numValue.toString();
};

// Utility to recursively format all numbers in an object for API payload
export const formatObjectForPayload = (obj) => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => formatObjectForPayload(item));
  }

  if (typeof obj === "object") {
    const formatted = {};
    for (const [key, value] of Object.entries(obj)) {
      formatted[key] = formatObjectForPayload(value);
    }
    return formatted;
  }

  if (typeof obj === "string" && /^\d+[,.]\d+$/.test(obj)) {
    // If it's a string that looks like a number with comma or dot
    return ensurePayloadFormat(obj);
  }

  return obj;
};

/**
 * CustomTable + AzilisSwitch pass "Yes" / "No" strings. Using `value || false` in API
 * payloads makes "No" truthy, so backends often persist true. Coerce to real booleans.
 */
export function azilisSwitchToBool(v) {
  if (v === true || v === "Yes") return true;
  if (v === false || v === "No") return false;
  return Boolean(v);
}
